import * as React from "react";
import { useFolderMutations } from "../../../../hooks";
import { FolderFormDialog } from "./FolderFormDialog";

interface EditFolderDialogProps {
  editDialogFolder: {
    id: number;
    label: string;
    user_ids: number[];
    group_ids: number[];
  } | null;
  onClose: () => void;
  organizationId: number;
}

export function EditFolderDialog(props: EditFolderDialogProps) {
  const { editDialogFolder, onClose, organizationId } = props;

  const { updateFolderAsync, isUpdating } = useFolderMutations(organizationId);

  const handleSubmit = async (name: string) => {
    if (editDialogFolder) {
      try {
        await updateFolderAsync({
          folderId: editDialogFolder.id,
          name,
        });
        onClose();
      } catch (error) {
        // Error already shown via toast
        // Dialog stays open so user can retry
      }
    }
  };

  return (
    <FolderFormDialog
      isOpen={editDialogFolder !== null}
      onClose={onClose}
      title="Edit Folder"
      onSubmit={handleSubmit}
      initialValue={editDialogFolder?.label || ""}
      isLoading={isUpdating}
      loadingText="Saving..."
      submitText="Save"
    />
  );
}
